
















































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Headerhome from '@/components/headerhome.vue';
import ajax from '@/lib/ajax';
import FlightOrderGeneral from '@/store/entities/flight/flightOrderGeneral';
import Flight from '@/store/entities/flight/flight';
import Passenger from '@/store/entities/order/passenger';
@Component({
  components: { Headerhome },
})
export default class FlightPayment extends Vue {
  birthday: Date = null;
  radios: boolean = true;
  radios1: boolean = true;
  radios2: boolean = true;
  radios3: boolean = true;
  customerGsm:string;
  customerEmail:string;
  flightOrderGeneral: FlightOrderGeneral = new FlightOrderGeneral();
  flight: Flight = new Flight();
  passenger: Passenger = new Passenger();
  async created() {
    const payload = {
      orderId: this.$route.params.orderId,
    };
    const response = await ajax.post(
      'api/services/app/Booking/GetOrderById',
      payload
    );

    this.flightOrderGeneral = response.data.result;
        this.customerGsm=this.flightOrderGeneral.customer.gsm;
        this.customerEmail=this.flightOrderGeneral.customer.email;

  }

  get pnrNumber() {
    return this.flightOrderGeneral.flightOrders
      ? this.flightOrderGeneral.orderNo
      : '';
  }

  get flightDuration() {
    return this.flightOrderGeneral.flightOrders
      ? this.flightOrderGeneral.flightOrders[0].flight.flightDuration
      : '';
  }
  get flightOw() {
    return this.flightOrderGeneral.flightOrders
      ? this.flightOrderGeneral.flightOrders[0].flight
      : this.flight;
  }
  get flightRt() {
    return this.flightOrderGeneral.flightOrders
      ? this.flightOrderGeneral.flightOrders[1].flight
      : this.flight;
  }
  get isFlightRt() {
    return this.flightOrderGeneral.flightOrders.length > 1 ? true : false;
  }

  get passengers() {
    return this.flightOrderGeneral.flightOrders
      ? this.flightOrderGeneral.flightOrders[0].passengers[0].passengers
      : this.passenger;

  }
}
